export default {
  socialNetworks: 'Soziale Netzwerke',
  sentEmails: 'Gesendete E-Mails',
  peoplePerDay: 'Menschen pro Tag',
  peoplePerMonth: 'Menschen pro Monat',
  statsPerApp: 'Anwendungsstatistiken',
  search: 'Suche',
  name: 'Namen',
  people: 'Menschen',
  person: 'Person',
  sentMessages: 'Gesendete Nachrichten',
  messagesParts: 'Nachrichtenteile',
  applicationsPerPage: 'Anwendungen pro Seite',
  cellphoneRecords: 'Handyaufzeichnungen',
  totalRecords: 'Gesamtzahl der Datensätze',
  noName: 'Namenlosen',
  noAppsToShow: 'Es gibt keine Apps zum Anzeigen',
  manualPayment: 'Manuelle Zahlung',
  manualCollection: 'Manuelle Sammlung',
  noDataYet: 'Es gibt derzeit keine Daten'
}
